import { ReactNode } from 'react';
import { useSessionTimeout } from '@/hooks/useSessionTimeout';

interface SessionTimeoutWrapperProps {
  children: ReactNode;
}

/**
 * Wrapper component to enable session timeout globally
 * Must be within Router context
 */
export const SessionTimeoutWrapper = ({ children }: SessionTimeoutWrapperProps) => {
  // Enable session timeout with default settings
  useSessionTimeout({
    idleTimeout: 30 * 60 * 1000, // 30 minutes
    absoluteTimeout: 8 * 60 * 60 * 1000, // 8 hours
    warningTime: 5 * 60 * 1000, // 5 minute warning
    enabled: true,
  });

  return <>{children}</>;
};
